import { useQuery } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

export function useBacktestRunsQuery(options = {}) {
  return useQuery({
    queryKey: ['backtestRuns'],
    queryFn: () => httpJSON('/v1/backtesting/runs'),
    staleTime: 30_000,
    ...options,
  });
}

export function useBacktestRunQuery(runId, options = {}) {
    return useQuery({
        queryKey: ['backtestRuns', runId],
        queryFn: () => httpJSON(`/v1/backtesting/runs/${runId}`),
        enabled: Boolean(runId),
        staleTime: 30_000,
        ...options,
    });
}

export function useBacktestSymbolTimelineQuery(runId, symbol, options = {}) {
  return useQuery({
    queryKey: ['backtestRuns', runId, 'symbolTimeline', symbol],
    queryFn: () => httpJSON(`/v1/backtesting/runs/${runId}/symbols/${symbol}`),
    enabled: Boolean(runId && symbol),
    staleTime: 10_000,
    ...options,
  });
}

export function useBacktestAvailabilityQuery(params = {}, options = {}) {
  const query = new URLSearchParams({
    'start-date': params.startDate ?? '2025-03-14',
    ...(params.endDate ? { 'end-date': params.endDate } : {}),
  }).toString();
  return useQuery({
    queryKey: ['backtestAvailability', params],
    queryFn: () => httpJSON(`/v1/backtesting/availability?${query}`),
    staleTime: 5 * 60_000,
    ...options,
  });
}
